<div mat-dialog-title class="text-base">
  <span class="text-orange-400">Terms of Use</span> &
  <span class="text-orange-400">Privacy Policy </span>Agreements
  <p class="text-sm">Open both agreements to enable the accept button</p>
</div>

<mat-dialog-content class="mat-typography">
  <div class="flex flex-col justify-center items-center gap-y-8 py-6">
    <mat-accordion class="w-full">
      <mat-expansion-panel (click)="clickedTerms.set(true)">
        <mat-expansion-panel-header>
          <mat-panel-title> Terms of Use </mat-panel-title>
          <!-- <mat-panel-description> Pdf document </mat-panel-description> -->
        </mat-expansion-panel-header>

        <iframe
          class="pdf"
          src="https://s3.ca-central-1.amazonaws.com/johnstonsconnected.com/legal/Terms+of+Use.pdf"
        >
        </iframe>
      </mat-expansion-panel>
      <mat-expansion-panel (click)="clickedPrivacy.set(true)">
        <mat-expansion-panel-header>
          <mat-panel-title> Privacy Policy </mat-panel-title>
          <!-- <mat-panel-description> Pdf document </mat-panel-description> -->
        </mat-expansion-panel-header>

        <iframe
          class="pdf"
          src="https://s3.ca-central-1.amazonaws.com/johnstonsconnected.com/legal/Privacy+Policy-+Johnston's+Connected.pdf"
        >
        </iframe>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="py-4">
  <button
    mat-raised-button
    color="primary"
    [disabled]="!clickedTerms() || !clickedPrivacy()"
    (click)="close(true)"
  >
    I Accept
  </button>
  <button
    mat-raised-button
    style="background-color: #da1111cc !important; color: white"
    (click)="close(false)"
  >
    Close
  </button>
</mat-dialog-actions>
